import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Chip,
  alpha,
  useTheme,
} from "@mui/material";
import { ArrowBack, Print, LocalOffer } from "@mui/icons-material";

const OfferHeader = ({ offerDetails, onBack, onPrint }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${alpha(
          theme.palette.error.main,
          0.8,
        )} 100%)`,
        p: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        boxShadow: `0 4px 12px ${alpha(theme.palette.error.main, 0.2)}`,
      }}
    >
      {/* Back Button */}
      <IconButton
        onClick={onBack}
        sx={{
          bgcolor: "white",
          color: theme.palette.error.main,
          "&:hover": {
            bgcolor: alpha("#fff", 0.9),
          },
        }}
      >
        <ArrowBack />
      </IconButton>

      {/* Offer Info */}
      <Box sx={{ flex: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
          <LocalOffer sx={{ color: "white", fontSize: 20 }} />
          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontWeight: 700,
              fontSize: "1.1rem",
            }}
          >
            {offerDetails.name}
          </Typography>
        </Box>
        <Typography
          variant="body2"
          sx={{
            color: alpha("#fff", 0.9),
            fontSize: "0.85rem",
          }}
        >
          {offerDetails.type.toUpperCase()} •{" "}
          {offerDetails.OfferItems?.length || 0} item
          {offerDetails.OfferItems?.length !== 1 ? "s" : ""}
        </Typography>
      </Box>

      {/* Status & Print */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Chip
          label={offerDetails.isActive ? "ACTIVE" : "INACTIVE"}
          size="small"
          sx={{
            bgcolor: "white",
            color: offerDetails.isActive
              ? theme.palette.success.main
              : theme.palette.grey[600],
            fontWeight: 700,
            fontSize: "0.7rem",
          }}
        />
        <IconButton
          onClick={onPrint}
          sx={{
            bgcolor: "white",
            color: theme.palette.error.main,
            "&:hover": {
              bgcolor: alpha("#fff", 0.9),
            },
          }}
        >
          <Print />
        </IconButton>
      </Box>
    </Box>
  );
};

export default OfferHeader;
